import React from 'react'
import { DefaultLayout } from '../../layouts'
import { PageHeader } from '../../components'
import { MainContent } from './components'
import { PAGE_IMAGE } from './config'
import { useInternationalization } from '../../features/i18n'

const Career = () => {
  const { translate } = useInternationalization()

  return (
    <DefaultLayout>
      <PageHeader
        title={translate('CAREER', 'singular')}
        description={translate('CAREER', 'page_description')}
        image={PAGE_IMAGE}
        className="py-4"
      />
      <MainContent />
    </DefaultLayout>
  )
}

export { Career }
